import { render } from "./RatePending.vue?vue&type=template&id=e9d2dc72"
import script from "./RatePending.vue?vue&type=script&lang=js"
export * from "./RatePending.vue?vue&type=script&lang=js"

import exportComponent from "D:\\PROJET WEB\\carpoolear\\carpoolear_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__